module.exports = __webpack_public_path__ + "static/media/sehatq.45704a12.webp";